const labels = {
  FaqCategories: {
    'Ref: Page title': '常见问题',
    'Ref: Missing Faq': '常见问题为空',
    'Ref: Go to home page': '转到主页',
  },
  FaqCategoryDetails: { 'Ref: Page title': '问题' },
};
export default labels;
